// extracted by mini-css-extract-plugin
export default {"tableWrapper":"A4scI3_"};